import { format, isSameMonth, isSameYear, parseISO } from 'date-fns';

import { type DateRangeValue, getDateRangePresetValue } from '@src/shared/lib/dateRangePresets';

// Shared by the dashboard tile and the detail page's DataRanger default, so the two stay in sync.
export const CLIENT_MIX_RANGE = getDateRangePresetValue('this_week');
export const DAILY_INVOICING_RANGE = getDateRangePresetValue('this_month');
export const DAILY_LABOUR_RANGE = getDateRangePresetValue('this_week');
export const OPENED_CASES_RANGE = getDateRangePresetValue('this_week');
export const TOP_CLIENTS_RANGE = getDateRangePresetValue('this_year');

/**
 * Tile subtitle; the start date omits whatever it shares with the end date:
 * "05 - 11.10.2026", "29.09 - 05.10.2026", "29.12.2025 - 04.01.2026".
 */
export function formatRangeDescription({ from, to }: DateRangeValue) {
  if (!from || !to) {
    return undefined;
  }

  const fromDate = parseISO(from);
  const toDate = parseISO(to);

  let fromFormat = 'dd.MM.yyyy';
  if (isSameMonth(fromDate, toDate)) {
    fromFormat = 'dd';
  } else if (isSameYear(fromDate, toDate)) {
    fromFormat = 'dd.MM';
  }

  return `${format(fromDate, fromFormat)} - ${format(toDate, 'dd.MM.yyyy')}`;
}
